import { render, staticRenderFns } from "./ReviewUpLimitReason.vue?vue&type=template&id=6b00066c"
import script from "./ReviewUpLimitReason.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimitReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports